import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon, MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-response-latency-modal',
  styleUrl: './response-latency-modal.component.scss',
  templateUrl: './response-latency-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIcon,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ResponseLatencyModalComponent {

  total: string = '';
  inserted: string = '';
  updated: string = '';
  error: string = '';

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
  }

  ngAfterViewInit():void {
    if (this.data && this.data.result) {
      const result = this.data.result
      this.total = result.total;
      this.inserted = result.inserted;
      this.updated = result.updated;
      this.error = result.error;
    
     /*  const responseParts = this.data.response.split(',');
      responseParts.forEach((part: string) => {
        const [key, value] = part.split(':');
        switch (key.trim()) {
          case 'T':
            this.total = value.trim();
            break;
          case 'E':
            this.error = value.trim();
            break;
          case 'S':
            this.inserted = value.trim();
            break;
          case 'U':
            this.updated = value.trim();
        }
      }); */
    }
  }
  
  onSubmit() {
    this.dialogRef.close("success")
  }
}


